// src/index.js - UPDATE THIS FILE
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './firebase/AuthContext';

// Initialize Sentry BEFORE rendering app
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  
  // Set environment (useful for filtering)
  environment: process.env.NODE_ENV, // 'development' or 'production'
  
  // Performance Monitoring
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Disable session replay for privacy with legal documents
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // Performance monitoring - track slow operations
  tracesSampleRate: 1.0, // 100% in beta, reduce to 0.1 (10%) in production
  
  // Session Replay - captures user sessions for errors
  // Only capture sessions with errors (privacy-friendly)
  replaysSessionSampleRate: 0, // Don't record normal sessions
  replaysOnErrorSampleRate: 1.0, // 100% of error sessions
  
  // Don't send errors in development
  enabled: process.env.NODE_ENV === 'production',
  
  // Filter out certain errors
  beforeSend(event, hint) {
    // Don't send certain errors
    const error = hint.originalException;
    
    // Ignore Firebase "missing or insufficient permissions" (expected for unauthorized access)
    if (error && error.message && error.message.includes('Missing or insufficient permissions')) {
      return null;
    }
    
    // Ignore network errors from flaky connections
    if (error && error.message && error.message.includes('Failed to fetch')) {
      return null;
    }
    
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Send web vitals to Sentry
reportWebVitals((metric) => {
  // Send performance metrics to Sentry
  Sentry.metrics.distribution(metric.name, metric.value, {
    unit: 'millisecond',
  });
});